import {
  WalletTransaction,
  WalletBalance,
  Discount,
  Invoice,
  Payments,
} from "@/features/financial-management/domain/financial-management.interface";
import {
  PaymentObjectArguments,
  WalletChargeObjectArguments,
} from "@core/server/domain/request.interface";
import {
  getFarmerDiscounts,
  getFarmerInvoices,
  GetFarmerInvoicesArguments,
  walletTransactions,
  payments,
  walletBalance,
  walletCharge,
} from "@/features/financial-management/data/datasources/financial-management-datasources";

export interface FinancialManagementRepository {
  _getFarmerInvoices: (
    args?: GetFarmerInvoicesArguments
  ) => Promise<Invoice[] | undefined>;
  _getFarmerDiscounts: () => Promise<Discount[] | undefined>;
  _walletCharge: ({
    amount,
    kindName,
  }: WalletChargeObjectArguments) => Promise<WalletTransaction | undefined>;
  _payments: ({
    walletTransactionId,
    returnTo,
  }: PaymentObjectArguments) => Promise<Payments | undefined>;
  _walletBalance: () => Promise<WalletBalance | undefined>;
  _walletTransactions: () => Promise<WalletTransaction[] | undefined>;
}

export class FinancialManagementRepositoryImpl
  implements FinancialManagementRepository
{
  _getFarmerInvoices = async (
    args?: GetFarmerInvoicesArguments
  ): Promise<Invoice[] | undefined> => {
    return await getFarmerInvoices(args);
  };
  _getFarmerDiscounts = async (): Promise<Discount[] | undefined> => {
    return await getFarmerDiscounts();
  };

  _walletCharge = async (
    requestObject: WalletChargeObjectArguments
  ): Promise<WalletTransaction | undefined> => {
    return await walletCharge(requestObject);
  };

  _payments = async ({
    walletTransactionId,
    returnTo,
  }: PaymentObjectArguments): Promise<Payments | undefined> => {
    return await payments({ walletTransactionId, returnTo });
  };

  _walletBalance = async (): Promise<WalletBalance | undefined> => {
    return await walletBalance();
  };

  _walletTransactions = async (): Promise<WalletTransaction[] | undefined> => {
    return await walletTransactions();
  };
}
